<template>
  <div><div class="inner-wrap">
    <div class="topnav" id="myTopnav" >
        <!-- <button v-on:click="test">Test get user uid</button> -->

        <!-- <div class="logout-wrap" v-on:click="logout">Log ud</div> -->
        <button v-on:click='isOpen = !isOpen' class="menu-wrap" >
          <icon v-if="!isOpen" class="iconClass" name="bars" scale="1.8"></icon>
          <icon v-if="isOpen" class="iconClass" name="close" scale="1.8"></icon>
        </button>
        <!-- <div class="name-wrap" >{{name}}</div> -->
        <!-- <div class="name-wrap"> -->
          <img class="logo-wrap" src="/static/LogoTest.png" alt="Mountain View">
        <!-- </div> -->

         <!-- sign-out -->
        <!-- <a  href="javascript:void(0);" style="font-size:25px;" class="icon" v-on:click="myFunction">&#9776;</a> -->
      </div>
      <transition name="slide">
      <div v-if="isOpen" class="dropDown">
        <img class="logo-wrap-hidden" src="/static/BlackLogo.png" alt="Mountain View">
        <div v-on:click='isOpen = !isOpen' class="textWrap" v-for="link in links">
          <router-link  v-bind:to="link.link" >{{link.text}}</router-link>
        </div>
        <div class="textWrap logout-wrap-hidden" v-on:click="logout">Log ud</div>
        <div class="emailText">
          {{email}}
        </div>
      </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { app } from '@/firebase'
// import bus from '../../bus.js'

export default {
  data () {
    return {
      links: [
        // {link: 'settings', text: 'Indstillinger'}, //stats landingbooking
        {link: 'roomInfo', text: 'Vaskerums info'},
        {link: 'booking', text: 'Booking'},
      ],
      isOpen: false,
    }
  },
  methods: {
    logout: function() {
      // alert('out')
      app.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    }
  },
  computed: {
    name: function () {
      return this.$nameOfUser
    },
    email: function () {
      return this.$emailOfUser
    }
  },
  beforeUpdate () {
    // console.log('teeest')
  }
}

</script>

<style scoped>


.slide-leave-active,
.slide-enter-active {
  transition: 0.8s;
}
.slide-enter {
  transform: translateX(-300px);
}
.slide-enter-to {
  transform: translateX(0px);
}


.slide-leave-to {
  transform: translateX(-300px);
}

* {
  box-sizing: border-box;
}
/* [v-cloak] {display: none} */

button {
  background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
}

body {
  margin:0;
}

.topnav {
  padding-bottom: 4px;
  z-index: 20;
  /* color: rgba(0, 0, 0, 0.6); */
  overflow: hidden;
  /* background-color: white; */
  background-color: #00BAE0;
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.24);
  color: orange;
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.1); */
  /* border-bottom: 1px solid white; */
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.6); */
}

.dropDown {
  font-weight: 400;
  font-size: 1.1rem;
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 250px;
  /* left: 0px;
  right: 0px; */
  z-index: 99;
  text-align: left;
  box-shadow: 0px 0px 20px 5px rgba(0, 0, 0, 0.24);
  /* box-shadow: inset 0px 18px 10px -12px rgba(0, 0, 0, 0.15), inset 0px -18px 10px -12px rgba(0, 0, 0, 0.15); */
  padding: 0px 15px 0px 10px;
  /* background-color: #00BAE0; */
  background-color: white;
  color: rgba(0, 0, 0, 0.7);
  /* border-bottom: 1px solid white; */
}

.dropDown a {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 20px;
}


.textWrap {
  display: block;
  width: 150px;
  padding-top: 5px;
}
.logout-wrap-hidden {
  position: relative;
  bottom: 0px;
  left: 0px;
  cursor: pointer;
  margin-top: 30px;
}

.logo {
  float: left;
  display: block;
}

.logo img {
  height: 100%;
  max-height: 70px;
  padding: 5px;
}

.topnav a, .logout-wrap, .name-wrap, .menu-Wrap {
  font-weight: bold;
  float: right;
  display: block;
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  padding: 12px 16px;
  text-decoration: none;
  font-size: 15px;
}

.menu-wrap {
  padding: 4px 15px 0px 0px;
}

.name-wrap {
  float: left;
  color: White;
}

.topnav .icon {
  display: none;
}

.logout-wrap, .menu-wrap {
  float: right;
  cursor: pointer;
  color: white;
}

.logo-wrap, .logo-wrap-hidden {
  display: block;
  margin-top: 11px;
  margin-left: 15px;
  height: 20px;
}

.logo-wrap-hidden {
  margin-bottom: 30px;
  margin-left: 0px;
}

.router-link-active {
  font-weight: bold;
  /* background-color: rgba(0, 0, 0, 0.05); */
}

.emailText {
  position: absolute;
  bottom: 35px;
  left: 15px;
  font-size: 0.8rem;
}

.logout-wrap-hidden {
  position: absolute;
  bottom: 50px;
  left: 15px;
}


</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue